import * as ACTION from './constants';
import apiService from '../apiService';
import {processApiRequest} from '../../Common/saga';

export function* fetchHistories(action) {
    yield processApiRequest(ACTION.FETCH_HISTORIES, () => apiService.getHistories(action.payload), action.payload);
}